import { RedirectNotice } from "./components/shared/redirect-notice/redirect-notice.component";
import { RouterOutlet } from "@angular/router";
import { Component } from '@angular/core';
import { AppHeader } from "./components/app-header/app-header.component";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RedirectNotice, AppHeader],
  templateUrl: './app.html'
})
export class App {}
